import React from 'react';
import { getSelectedSubjects, getSelectedSubjectName, getSelectedLocations } from '../../../../actions';
import { EmbedHeader } from '../../../../components';
import { useAppContext } from '../../../../context/AppState.jsx';
import TitleWithNames from '../../../../components/NameTitle/index.jsx';

export default function Header() {
	const [state, dispatch] = useAppContext();
	if (!state.descriptors) {
		return null;
	}
	const linkToSource = `${window.location.origin}/data.html${window.location.search}`;
	const titleText = (
		<TitleWithNames
			subjectNames={getSelectedSubjects(state).map((s) => getSelectedSubjectName(state, s))}
			locations={getSelectedLocations(state)}
		/>
	);

	return <EmbedHeader titleText={titleText} linkToSource={linkToSource} />;
}
